import styled from 'styled-components';

export const TextAndImageContainer = styled.div`
    width: 100%;
    height: auto;
    margin: ${window.screen.width <= 1000 ? '0' : '70px 0 70px 0'}; 
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;


    .image-box{
        width: 650px;
        max-width: ${window.screen.width <= 1000 ? '90%' : '40%'}; 
        box-shadow: black 0px 0px 5px;
        height: 650px;
        max-height: 55vh;
        margin: 35px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        align-self: center;
    }

    .text-box {
        background-color: rgba(0,0,0,0.5);
        box-shadow: black 0px 0px 2px;
        width: 650px;
        max-width: ${window.screen.width <= 1000 ? '90%' : '40%'}; 
        height: 650px;
        max-height: 55vh;
        margin: 35px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .text {
            width: 85%;
        }

         h5 {
           font-size: ${window.screen.width <= 1000 ? '20px' : '30px'}; 
           padding: 0;
           margin: 0;
        }
        
        p {
           font-size: ${window.screen.width <= 1000 ? '17px' : '25px'}; 
           margin: 0.5em 0 1em 0;
        }

        .p-bottom {
            margin-bottom: 0;
        }
    }
`;